// We do it first, then again once the rewardify script does it's bit
validateCheckout(0);

$('body').on('DOMNodeInserted update', 'span.rewardify-redeemed-amount', function() {
  let redeem = $('span.rewardify-redeemed-amount').text();
  let val = Number(redeem.replace(/[^0-9.-]+/g,"")) * 100;

  console.log('rewardify-redeemed-amount created or update', val, redeem);
  validateCheckout(val);
});

$('body').on('DOMNodeInserted update', 'button.rewardify-redeem-credit-cart', function() {
  let redeem = $('.rewardify-redeemed-amount').text();
  let val = Number(redeem.replace(/[^0-9.-]+/g,"")) * 100;

  console.log('rewardify cart BUTTON created or update', val);
  validateCheckout(val);
});

function validateCheckout(discount = 0) {
  console.log('discount', discount, 'is being used');
  let remain = parseFloat($('#spend-remain').val());
  let cart = parseFloat($('#cart_sub_total').val());
  let limit = parseFloat($('#spend-limit').val());
  let year_spent = parseFloat($('#orders_total').val());
  let warn = false;
  let balance = limit - year_spent;
  let cartRemain = cart - discount;
  console.log('cartRemain', cartRemain);

  if (limit > 0) {
  
  // In case they redeem more store credit than the balance of the cart
  if (discount > cart)
    discount = cart;

  console.log('Remaining: '+remain / 100, 'Discount: '+discount / 100, 'Cart total: '+cart / 100, 'Limit: '+limit / 100);

  // We have a discount and the discount is the cart amount
  if (discount > 0 && discount == cart) {
    $('.cash-remaining').text('$'+formatNumber((remain + discount) / 100));
    $('.checkout-button-grp input[type=submit]').attr('disabled', false).removeClass('hidden');
    return;
  }
  // We have a discount, but it doesn't cover the cost of the items
  else if (discount > 0 && discount < cart) {
    if (cartRemain > 0) {
      $('.cash-remaining').text('$'+formatNumber((balance - cartRemain) / 100));
      // Warn if they will not have sufficient cash balance to cover the shortfall
      warn = (balance > cartRemain)? false : true;
    }
    else {
      console.log('cartRemain is 0');
      $('.cash-remaining').text('$'+formatNumber(remain / 100));
      warn = false;
    }
  }
  // No discount, we are using cash only
  else {
  	$('.cash-remaining').text('$'+formatNumber(remain / 100));
    if (remain < cart)
      warn = true;
  }

  // Highlights the cash remaining field with red
  if (warn)
    $('.cash-remaining').addClass('error');
  else
    $('.cash-remaining').removeClass('error');


  // We only disable the checkout process if the customer has a limit
    // If the remaining balance minus any applied credit is less than the cart, then we need to invalidate the checkout
    if (remain + discount < 0) {
      $('.checkout-button-grp input[type=submit]').attr('disabled', true).val('Insufficient Balance');
      console.log('hiding checkout, insufficient balance');
    }
    else {
      $('.checkout-button-grp input[type=submit]').attr('disabled', false).val('CHECK OUT');
      $('.over-order').addClass('hidden');
      console.log('Checkout, okay');
    }
    
  }
}

function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}